import { SelectOption } from '@web-for-marketing/react-ui';

const countryOptions: SelectOption[] = [
    { value: 'US', content: 'United States' },
    { value: 'CA', content: 'Canada' },
    { value: 'AF', content: 'Afghanistan' },
    { value: 'AX', content: 'Aland Islands' },
    { value: 'AL', content: 'Albania' },
    { value: 'DZ', content: 'Algeria' },
    { value: 'AD', content: 'Andorra' },
    { value: 'AO', content: 'Angola' },
    { value: 'AI', content: 'Anguilla' },
    { value: 'AQ', content: 'Antarctica' },
    { value: 'AG', content: 'Antigua and Barbuda' },
    { value: 'AR', content: 'Argentina' },
    { value: 'AM', content: 'Armenia' },
    { value: 'AW', content: 'Aruba' },
    { value: 'AU', content: 'Australia' },
    { value: 'AT', content: 'Austria' },
    { value: 'AZ', content: 'Azerbaijan' },
    { value: 'BS', content: 'Bahamas' },
    { value: 'BH', content: 'Bahrain' },
    { value: 'BD', content: 'Bangladesh' },
    { value: 'BB', content: 'Barbados' },
    { value: 'BY', content: 'Belarus' },
    { value: 'BE', content: 'Belgium' },
    { value: 'BZ', content: 'Belize' },
    { value: 'BJ', content: 'Benin' },
    { value: 'BM', content: 'Bermuda' },
    { value: 'BT', content: 'Bhutan' },
    { value: 'BO', content: 'Bolivia, Plurinational State of' },
    { value: 'BQ', content: 'Bonaire, Sint Eustatius and Saba' },
    { value: 'BA', content: 'Bosnia and Herzegovina' },
    { value: 'BW', content: 'Botswana' },
    { value: 'BV', content: 'Bouvet Island' },
    { value: 'BR', content: 'Brazil' },
    { value: 'IO', content: 'British Indian Ocean Territory' },
    { value: 'BN', content: 'Brunei Darussalam' },
    { value: 'BG', content: 'Bulgaria' },
    { value: 'BF', content: 'Burkina Faso' },
    { value: 'BI', content: 'Burundi' },
    { value: 'KH', content: 'Cambodia' },
    { value: 'CM', content: 'Cameroon' },
    { value: 'CV', content: 'Cape Verde' },
    { value: 'KY', content: 'Cayman Islands' },
    { value: 'CF', content: 'Central African Republic' },
    { value: 'TD', content: 'Chad' },
    { value: 'CL', content: 'Chile' },
    { value: 'CX', content: 'Christmas Island' },
    { value: 'CC', content: 'Cocos (Keeling) Islands' },
    { value: 'CO', content: 'Colombia' },
    { value: 'KM', content: 'Comoros' },
    { value: 'CG', content: 'Congo' },
    { value: 'CD', content: 'Congo, the Democratic Republic of the' },
    { value: 'CK', content: 'Cook Islands' },
    { value: 'CR', content: 'Costa Rica' },
    { value: 'CI', content: 'Cote d\'Ivoire' },
    { value: 'HR', content: 'Croatia' },
    { value: 'CW', content: 'Curaçao' },
    { value: 'CY', content: 'Cyprus' },
    { value: 'CZ', content: 'Czech Republic' },
    { value: 'DK', content: 'Denmark' },
    { value: 'DJ', content: 'Djibouti' },
    { value: 'DM', content: 'Dominica' },
    { value: 'DO', content: 'Dominican Republic' },
    { value: 'EC', content: 'Ecuador' },
    { value: 'EG', content: 'Egypt' },
    { value: 'SV', content: 'El Salvador' },
    { value: 'GQ', content: 'Equatorial Guinea' },
    { value: 'ER', content: 'Eritrea' },
    { value: 'EE', content: 'Estonia' },
    { value: 'ET', content: 'Ethiopia' },
    { value: 'FK', content: 'Falkland Islands (Malvinas)' },
    { value: 'FO', content: 'Faroe Islands' },
    { value: 'FJ', content: 'Fiji' },
    { value: 'FI', content: 'Finland' },
    { value: 'FR', content: 'France' },
    { value: 'GF', content: 'French Guiana' },
    { value: 'PF', content: 'French Polynesia' },
    { value: 'TF', content: 'French Southern Territories' },
    { value: 'GA', content: 'Gabon' },
    { value: 'GM', content: 'Gambia' },
    { value: 'GE', content: 'Georgia' },
    { value: 'DE', content: 'Germany' },
    { value: 'GH', content: 'Ghana' },
    { value: 'GI', content: 'Gibraltar' },
    { value: 'GR', content: 'Greece' },
    { value: 'GL', content: 'Greenland' },
    { value: 'GD', content: 'Grenada' },
    { value: 'GP', content: 'Guadeloupe' },
    { value: 'GT', content: 'Guatemala' },
    { value: 'GG', content: 'Guernsey' },
    { value: 'GN', content: 'Guinea' },
    { value: 'GW', content: 'Guinea-Bissau' },
    { value: 'GY', content: 'Guyana' },
    { value: 'HT', content: 'Haiti' },
    { value: 'HM', content: 'Heard Island and McDonald Islands' },
    { value: 'VA', content: 'Holy See (Vatican City State)' },
    { value: 'HN', content: 'Honduras' },
    { value: 'HU', content: 'Hungary' },
    { value: 'IS', content: 'Iceland' },
    { value: 'IN', content: 'India' },
    { value: 'ID', content: 'Indonesia' },
    { value: 'IQ', content: 'Iraq' },
    { value: 'IE', content: 'Ireland' },
    { value: 'IM', content: 'Isle of Man' },
    { value: 'IL', content: 'Israel' },
    { value: 'IT', content: 'Italy' },
    { value: 'JM', content: 'Jamaica' },
    { value: 'JP', content: 'Japan' },
    { value: 'JE', content: 'Jersey' },
    { value: 'JO', content: 'Jordan' },
    { value: 'KZ', content: 'Kazakhstan' },
    { value: 'KE', content: 'Kenya' },
    { value: 'KI', content: 'Kiribati' },
    { value: 'KR', content: 'Korea, Republic of' },
    { value: 'KW', content: 'Kuwait' },
    { value: 'KG', content: 'Kyrgyzstan' },
    { value: 'LA', content: 'Lao People\'s Democratic Republic' },
    { value: 'LV', content: 'Latvia' },
    { value: 'LB', content: 'Lebanon' },
    { value: 'LS', content: 'Lesotho' },
    { value: 'LR', content: 'Liberia' },
    { value: 'LY', content: 'Libya' },
    { value: 'LI', content: 'Liechtenstein' },
    { value: 'LT', content: 'Lithuania' },
    { value: 'LU', content: 'Luxembourg' },
    { value: 'MO', content: 'Macao' },
    { value: 'MK', content: 'Macedonia, the former Yugoslav Republic of' },
    { value: 'MG', content: 'Madagascar' },
    { value: 'MW', content: 'Malawi' },
    { value: 'MY', content: 'Malaysia' },
    { value: 'MV', content: 'Maldives' },
    { value: 'ML', content: 'Mali' },
    { value: 'MT', content: 'Malta' },
    { value: 'MQ', content: 'Martinique' },
    { value: 'MR', content: 'Mauritania' },
    { value: 'MU', content: 'Mauritius' },
    { value: 'YT', content: 'Mayotte' },
    { value: 'MX', content: 'Mexico' },
    { value: 'MD', content: 'Moldova, Republic of' },
    { value: 'MC', content: 'Monaco' },
    { value: 'MN', content: 'Mongolia' },
    { value: 'ME', content: 'Montenegro' },
    { value: 'MS', content: 'Montserrat' },
    { value: 'MA', content: 'Morocco' },
    { value: 'MZ', content: 'Mozambique' },
    { value: 'MM', content: 'Myanmar' },
    { value: 'NA', content: 'Namibia' },
    { value: 'NR', content: 'Nauru' },
    { value: 'NP', content: 'Nepal' },
    { value: 'NL', content: 'Netherlands' },
    { value: 'NC', content: 'New Caledonia' },
    { value: 'NZ', content: 'New Zealand' },
    { value: 'NI', content: 'Nicaragua' },
    { value: 'NE', content: 'Niger' },
    { value: 'NG', content: 'Nigeria' },
    { value: 'NU', content: 'Niue' },
    { value: 'NF', content: 'Norfolk Island' },
    { value: 'NO', content: 'Norway' },
    { value: 'OM', content: 'Oman' },
    { value: 'PK', content: 'Pakistan' },
    { value: 'PS', content: 'Palestine' },
    { value: 'PA', content: 'Panama' },
    { value: 'PG', content: 'Papua New Guinea' },
    { value: 'PY', content: 'Paraguay' },
    { value: 'PE', content: 'Peru' },
    { value: 'PH', content: 'Philippines' },
    { value: 'PN', content: 'Pitcairn' },
    { value: 'PL', content: 'Poland' },
    { value: 'PT', content: 'Portugal' },
    { value: 'QA', content: 'Qatar' },
    { value: 'RE', content: 'Reunion' },
    { value: 'RO', content: 'Romania' },
    { value: 'RW', content: 'Rwanda' },
    { value: 'BL', content: 'Saint Barthélemy' },
    { value: 'SH', content: 'Saint Helena, Ascension and Tristan da Cunha' },
    { value: 'KN', content: 'Saint Kitts and Nevis' },
    { value: 'LC', content: 'Saint Lucia' },
    { value: 'MF', content: 'Saint Martin (French part)' },
    { value: 'PM', content: 'Saint Pierre and Miquelon' },
    { value: 'VC', content: 'Saint Vincent and the Grenadines' },
    { value: 'WS', content: 'Samoa' },
    { value: 'SM', content: 'San Marino' },
    { value: 'ST', content: 'Sao Tome and Principe' },
    { value: 'SA', content: 'Saudi Arabia' },
    { value: 'SN', content: 'Senegal' },
    { value: 'RS', content: 'Serbia' },
    { value: 'SC', content: 'Seychelles' },
    { value: 'SL', content: 'Sierra Leone' },
    { value: 'SG', content: 'Singapore' },
    { value: 'SX', content: 'Sint Maarten (Dutch part)' },
    { value: 'SK', content: 'Slovakia' },
    { value: 'SI', content: 'Slovenia' },
    { value: 'SB', content: 'Solomon Islands' },
    { value: 'SO', content: 'Somalia' },
    { value: 'ZA', content: 'South Africa' },
    { value: 'GS', content: 'South Georgia and the South Sandwich Islands' },
    { value: 'ES', content: 'Spain' },
    { value: 'LK', content: 'Sri Lanka' },
    { value: 'SR', content: 'Suriname' },
    { value: 'SJ', content: 'Svalbard and Jan Mayen' },
    { value: 'SZ', content: 'Swaziland' },
    { value: 'SE', content: 'Sweden' },
    { value: 'CH', content: 'Switzerland' },
    { value: 'TW', content: 'Taiwan' },
    { value: 'TJ', content: 'Tajikistan' },
    { value: 'TZ', content: 'Tanzania, United Republic of' },
    { value: 'TH', content: 'Thailand' },
    { value: 'TL', content: 'Timor-Leste' },
    { value: 'TG', content: 'Togo' },
    { value: 'TK', content: 'Tokelau' },
    { value: 'TO', content: 'Tonga' },
    { value: 'TT', content: 'Trinidad and Tobago' },
    { value: 'TN', content: 'Tunisia' },
    { value: 'TR', content: 'Turkey' },
    { value: 'TM', content: 'Turkmenistan' },
    { value: 'TC', content: 'Turks and Caicos Islands' },
    { value: 'TV', content: 'Tuvalu' },
    { value: 'UG', content: 'Uganda' },
    { value: 'UA', content: 'Ukraine' },
    { value: 'AE', content: 'United Arab Emirates' },
    { value: 'GB', content: 'United Kingdom' },
    { value: 'UY', content: 'Uruguay' },
    { value: 'UZ', content: 'Uzbekistan' },
    { value: 'VU', content: 'Vanuatu' },
    { value: 'VE', content: 'Venezuela, Bolivarian Republic of' },
    { value: 'VN', content: 'Viet Nam' },
    { value: 'VG', content: 'Virgin Islands, British' },
    { value: 'WF', content: 'Wallis and Futuna' },
    { value: 'EH', content: 'Western Sahara' },
    { value: 'YE', content: 'Yemen' },
    { value: 'ZM', content: 'Zambia' },
    { value: 'ZW', content: 'Zimbabwe' },
];

export default countryOptions;
